export function queryStringToRecord(queryString: Nullable<string>): Record<string, string> {
  if (!queryString) return {};

  const searchParams = new URLSearchParams(queryString);

  const result: Record<string, string> = {};
  searchParams.forEach((value, key) => {
    result[key] = value;
  });

  return result;
}
